import { render, staticRenderFns } from "./GroupsPagination.vue?vue&type=template&id=1f92b56f"
import script from "./GroupsPagination.vue?vue&type=script&lang=js"
export * from "./GroupsPagination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports